import {
    GET_SURVEY_GROUPS_REQUEST,
    GET_SURVEY_GROUPS_SUCCESS,
    GET_SURVEY_GROUPS_FAIL,
    GET_SURVEY_GROUP_DETAIL_REQUEST,
    GET_SURVEY_GROUP_DETAIL_SUCCESS,
    GET_SURVEY_GROUP_DETAIL_FAIL,
    CREATE_SURVEY_GROUP_REQUEST,
    CREATE_SURVEY_GROUP_SUCCESS,
    CREATE_SURVEY_GROUP_FAIL,
    UPDATE_SURVEY_GROUP_REQUEST,
    UPDATE_SURVEY_GROUP_SUCCESS,
    UPDATE_SURVEY_GROUP_FAIL,
    DELETE_SURVEY_GROUP_REQUEST,
    DELETE_SURVEY_GROUP_SUCCESS,
    DELETE_SURVEY_GROUP_FAIL
} from "../constant";

const initialState = {
    groupList: [],
    groupListLoading: false,
    groupDetail: null,
    groupDetailLoading: false,
    groupItems: [],
    groupMutationLoading: false,
};

export const surveyGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get survey groups
        case GET_SURVEY_GROUPS_REQUEST:
            return {
                ...state,
                groupListLoading: true
            };
        case GET_SURVEY_GROUPS_SUCCESS:
            const rawGroups = action.payload?.data || [];
            const mappedGroups = rawGroups.map((row) => ({
                id: row.su_group_id,
                name: row.su_group_title,
                surveyCount: row.total_surveys ?? 0,
                status: 1, // backend does not expose group status yet; default to Published
                added_on: row.su_add_date_time || null,
                added_by: row.added_by_name || null,
                published_on: row.su_add_date_time || null // Use add date time as published date for now
            }));
            return {
                ...state,
                groupList: mappedGroups,
                groupListLoading: false
            };
        case GET_SURVEY_GROUPS_FAIL:
            return {
                ...state,
                groupListLoading: false
            };

        // Get survey group detail
        case GET_SURVEY_GROUP_DETAIL_REQUEST:
            return {
                ...state,
                groupDetailLoading: true
            };
        case GET_SURVEY_GROUP_DETAIL_SUCCESS:
            return {
                ...state,
                groupDetail: action.payload?.data?.group || null,
                groupItems: action.payload?.data?.items || [],
                groupDetailLoading: false
            };
        case GET_SURVEY_GROUP_DETAIL_FAIL:
            return {
                ...state,
                groupDetailLoading: false
            };

        // Create survey group
        case CREATE_SURVEY_GROUP_REQUEST:
            return {
                ...state,
                groupMutationLoading: true
            };
        case CREATE_SURVEY_GROUP_SUCCESS:
            return {
                ...state,
                groupMutationLoading: false
            };
        case CREATE_SURVEY_GROUP_FAIL:
            return {
                ...state,
                groupMutationLoading: false
            };

        // Update survey group
        case UPDATE_SURVEY_GROUP_REQUEST:
            return {
                ...state,
                groupMutationLoading: true
            };
        case UPDATE_SURVEY_GROUP_SUCCESS:
            return {
                ...state,
                groupMutationLoading: false
            };
        case UPDATE_SURVEY_GROUP_FAIL:
            return {
                ...state,
                groupMutationLoading: false
            };

        // Delete survey group
        case DELETE_SURVEY_GROUP_REQUEST:
            return {
                ...state,
                groupMutationLoading: true
            };
        case DELETE_SURVEY_GROUP_SUCCESS:
            return {
                ...state,
                groupMutationLoading: false
            };
        case DELETE_SURVEY_GROUP_FAIL:
            return {
                ...state,
                groupMutationLoading: false
            };

        default:
            return state;
    }
};

